import { render, staticRenderFns } from "./EstablishmentRoleDelete.vue?vue&type=template&id=308a0277&"
import script from "./EstablishmentRoleDelete.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports